import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const EMPTY_ARRAY = [];

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchStatusOfIncident () {
  return fetch('/referenceData/getDropdownOptions?dropdown=incident.status')
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the status of incident');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve the status of incident. Please reload the page and try again');
    });
}

const useStatusOfIncident = (shouldLoad) => {
  const { data } = useQuery({
    queryKey: ['useStatusOfIncident'],
    queryFn: fetchStatusOfIncident,
    refetchOnWindowFocus: false,
    enabled: shouldLoad,
    staleTime: Infinity
  });

  return data ?? EMPTY_ARRAY;
};

export default useStatusOfIncident;
